import { render } from "./user-suivi.vue?vue&type=template&id=50962fda&scoped=true"
import script from "./user-suivi.vue?vue&type=script&lang=js"
export * from "./user-suivi.vue?vue&type=script&lang=js"

import "./user-suivi.vue?vue&type=style&index=0&id=50962fda&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50962fda"]])

export default __exports__